import { ErrorMessage } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { $viewError } from '../model'

export const SignInErrorMessage = () => {
  const { t } = useTranslation()
  const errorKey = useUnit($viewError)

  if (!errorKey) return null

  return <ErrorMessage width='100%' title={t(errorKey)} />
}
